"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_TYPE = void 0;
var FILE_TYPE;
(function (FILE_TYPE) {
    FILE_TYPE["ORGANIZATION_LOGO"] = "ORGANIZATION_LOGO";
    FILE_TYPE["POI_MGMT_LOCATION_LIST_UPLOAD"] = "POI_MGMT_LOCATION_LIST_UPLOAD";
})(FILE_TYPE || (exports.FILE_TYPE = FILE_TYPE = {}));
const getS3FileUploadURL = (accessToken, filename, fileType, callback = () => {
}) => {
    try {
        fetch(`${process.env.HUB_API_URL}/api/v1/resources/static/upload_url?type=${fileType}&fileName=${filename}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback && callback(result));
    }
    catch (e) {
        console.error(`/api/v1/resources/static/upload_url?type=${fileType}&fileName=${filename}: ${e}`);
    }
};
const getS3FileDownloadURL = (accessToken, s3Path, fileType, callback = () => {
}) => {
    try {
        fetch(`${process.env.HUB_API_URL}/api/v1/resources/static/download_url?type=${fileType}&s3Path=${s3Path}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback && callback(result));
    }
    catch (e) {
        console.error(`/api/v1/resources/static/download_url?type=${fileType}&s3Path=${s3Path}: ${e}`);
    }
};
const uploadFileToS3 = (file, presignedUrl, callback, onError) => {
    fetch(presignedUrl, {
        method: 'PUT',
        body: file
    })
        .then(response => {
        if (response.ok)
            callback(response);
        else {
            return response.text().then(text => Promise.reject(`Failed to upload: ${text}`));
        }
    })
        .catch(error => {
        console.error(`${presignedUrl}: ${error}`);
        onError(error);
    });
};
const processFileUpload = (accessToken, fileName, fileType, file, callback, onError) => {
    try {
        getS3FileUploadURL(accessToken, fileName, fileType, (fileUploadResponse) => {
            try {
                uploadFileToS3(file, fileUploadResponse.presignedUrl, () => callback({ s3Path: fileUploadResponse.s3Path, presignedUrl: fileUploadResponse.presignedUrl }));
            }
            catch (e) {
                console.error(`Issue uploading logo file to S3: ${e}`);
                onError && onError(e);
            }
        });
    }
    catch (error) {
        console.error('Failed to upload logo:', error);
        onError && onError(error);
    }
};
const Services = {
    getS3FileUploadURL,
    getS3FileDownloadURL,
    uploadFileToS3,
    processFileUpload
};
exports.default = Services;
